import type { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('../layouts/shell-layout/shell-layout').then((m) => m.ShellLayout),
    loadChildren: () => import('../features/feature-routes').then((m) => m.featureRoutes),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
  {
    path: 'not-found',
    loadComponent: () => import('../features/not-found/not-found').then((m) => m.NotFound),
  },
];
